import FileUploader from 'components/UploaderAndDownloader/FileUploader';
import DownloadBtn from 'modules/Entertainment/Videos/EditVideo/components/Forms/components/EditForm/InputFields/components/VideoFileBlock/DownloadBtn';
import React, { useCallback, useContext } from 'react';
import { createAppError } from 'utils/helpers';
import { AppContext, IAppContext } from 'appState/appContext';
import { IFileData } from 'types';
import { TTypeOfEditVideoModalWindow } from '../../../../../../../editVideoState/editVideoContext';
import { postMediaFile } from 'backend/additionalInformation';
import style from './VideoFileBlock.module.scss';

interface IVideoFileBlock {
	changeFileData: (value: IFileData) => void;
	changeTypeOfModalWindow: (value: TTypeOfEditVideoModalWindow) => void;
}

const VideoFileBlock: React.FC<IVideoFileBlock> = ({ changeFileData, changeTypeOfModalWindow }) => {
	const { showLoader, hideLoader, addAppError } = useContext<IAppContext>(AppContext);

	const sendForm = useCallback(
		async (file: File, callback: (value: string) => void) => {
			const maxFileSizeMB = 150;
			if (file.size > 1000 * 1000 * maxFileSizeMB) {
				changeTypeOfModalWindow('fileSizeExceeded');
				return null;
			}
			showLoader();
			const formData = new FormData();
			formData.append('file', file, file.name);

			try {
				const { data } = await postMediaFile({ data: formData });
				changeFileData({ fileId: data.fileId, fileHash: data.fileHash, fileName: file.name });
				callback(file.name);
				hideLoader();
			} catch (err) {
				hideLoader();
				const error = err as Error;
				const appError = createAppError(error);
				addAppError(appError);
			}
		},
		[changeTypeOfModalWindow, changeFileData],
	);

	const resetFile = useCallback(() => {
		changeFileData({ fileId: '', fileHash: null, fileName: null });
	}, [changeFileData]);

	return (
		<div className={style.container} data-test="VideoFileBlock">
			<FileUploader
				fileType="mp4"
				onFileLoad={sendForm}
				onFileReset={resetFile}
				id="videoUpload"
				label="uploadVideoFileButton"
			/>
			<DownloadBtn />
		</div>
	);
};

export default React.memo(VideoFileBlock);
